// extracted by mini-css-extract-plugin
export var formContainer = "_e1-0";
export var message = "_e1-1";